import { Debate, Turn } from '../types';

export const mockDebates: Debate[] = [
  {
    id: '1',
    topic: 'Should AI development be regulated by international treaties?',
    description: 'A debate on whether artificial intelligence advancement should be governed by binding international agreements.',
    status: 'live',
    sideA: {
      position: 'Regulation needed',
      color: '#3A68A0'
    },
    sideB: {
      position: 'Innovation first',
      color: '#E5442D'
    },
    voteCount: 34,
    currentRound: 2,
    totalRounds: 3,
    tags: ['Technology', 'Policy', 'AI'],
    createdAt: new Date('2024-10-10T10:00:00'),
    startedAt: new Date('2024-10-10T14:00:00')
  },
  {
    id: '2',
    topic: 'Is remote work better for productivity than office work?',
    description: 'Examining whether distributed teams outperform traditional office-based teams.',
    status: 'finished',
    sideA: {
      position: 'Remote is better',
      color: '#3A68A0'
    },
    sideB: {
      position: 'Office is better',
      color: '#E5442D'
    },
    voteCount: 12,
    totalRounds: 3,
    tags: ['Business', 'Productivity'],
    createdAt: new Date('2024-10-09T10:00:00'),
    startedAt: new Date('2024-10-09T14:00:00'),
    finishedAt: new Date('2024-10-09T15:30:00')
  },
  {
    id: '3',
    topic: 'Should social media platforms be liable for user content?',
    description: 'Debating platform responsibility versus free speech principles.',
    status: 'upcoming',
    sideA: {
      position: 'Hold platforms liable',
      color: '#3A68A0'
    },
    sideB: {
      position: 'Protect free speech',
      color: '#E5442D'
    },
    voteCount: 8,
    totalRounds: 3,
    tags: ['Technology', 'Law', 'Ethics'],
    createdAt: new Date('2024-10-10T08:00:00')
  },
  {
    id: '4',
    topic: 'Is universal basic income economically viable?',
    description: 'Analyzing the feasibility of implementing UBI in modern economies.',
    status: 'finished',
    sideA: {
      position: 'UBI is viable',
      color: '#3A68A0'
    },
    sideB: {
      position: 'UBI is unsustainable',
      color: '#E5442D'
    },
    voteCount: 24,
    totalRounds: 3,
    tags: ['Economics', 'Policy'],
    createdAt: new Date('2024-10-08T10:00:00'),
    startedAt: new Date('2024-10-08T14:00:00'),
    finishedAt: new Date('2024-10-08T15:45:00')
  }
];

export const mockTurns: Turn[] = [
  {
    id: 't1',
    debateId: '1',
    side: 'A',
    type: 'opening',
    content: 'AI development has reached a critical juncture where its potential for both benefit and harm requires coordinated global oversight. Without international treaties, we risk a dangerous race to the bottom in AI safety standards.',
    timestamp: new Date('2024-10-10T14:00:00')
  },
  {
    id: 't2',
    debateId: '1',
    side: 'B',
    type: 'opening',
    content: 'Innovation thrives in environments of freedom and competition. International treaties would stifle AI development, putting compliant nations at a disadvantage while bad actors ignore the rules anyway.',
    timestamp: new Date('2024-10-10T14:05:00')
  },
  {
    id: 't3',
    debateId: '1',
    side: 'A',
    type: 'rebuttal',
    content: 'The argument that treaties stifle innovation ignores successful precedents like aviation safety standards, which enhanced rather than hindered progress. Moreover, the existential risks of unregulated AI far outweigh temporary competitive advantages.',
    timestamp: new Date('2024-10-10T14:10:00')
  },
  {
    id: 't4',
    debateId: '1',
    side: 'B',
    type: 'rebuttal',
    content: 'Aviation is a false analogy - AI development is far more complex and rapidly evolving. Treaties move at the speed of bureaucracy while AI advances exponentially. We need flexible, industry-led standards, not rigid international law.',
    timestamp: new Date('2024-10-10T14:15:00'),
    isTyping: true
  }
];

export const liveDebateTicker = [
  'AI Regulation: "Treaties needed" vs "Innovation first" - Round 2 underway',
  'Starting soon: Social Media Liability debate at 3:00 PM'
];
